import { TblCol, TblFltOption } from '../../../../core/table/table.types';
import { tblSpecAddColumn } from '../../../../core/table/spec';
import { TblViewSpec } from '../../../../core/table/table-view.types';

export type ColKey = '' | 'Id' | 'Name' | 'SupportsEDI' | 'SenderId' | 'ReceiverId' | 'Type' | 'ObjectState';

function ediTypeOptions(): TblFltOption[] {
    return [
        { lbl: 'ALL', val: '' },
        { lbl: 'YES', val: 'YES' },
        { lbl: 'NO', val: 'NO' },
    ];
}

function vendorTypeOptions(): TblFltOption[] {
    return [
        { lbl: 'ALL', val: '' },
        { lbl: 'ACTIVE', val: 'ACTIVE' },
        { lbl: 'INACTIVE', val: 'INACTIVE' },
    ];
}

function typeTypeOptions(): TblFltOption[] {
    return [
        { lbl: 'ALL', val: '' },
        { lbl: 'MANUFACTURER', val: 'MANUFACTURER' },
        { lbl: 'PBM', val: 'PBM' },
        { lbl: 'TPA', val: 'TPA' },
        { lbl: 'WHOLESALER', val: 'WHOLESALER' },
    ];
}

// column spec (map the keys to the column types)
export function vendorListColumnSpec(): Map<ColKey, TblCol> {
    const map = new Map<ColKey, TblCol>();
    tblSpecAddColumn<ColKey>(map, 'Id', { title: 'ID', width: '35px' });
    tblSpecAddColumn<ColKey>(map, 'Name', { width: '60px' });
    tblSpecAddColumn<ColKey>(map, 'SupportsEDI', {
        type: 'DROPTEXT',
        title: 'Supports EDI',
        width: '60px',
        fltOptions: ediTypeOptions(),
    });
    tblSpecAddColumn<ColKey>(map, 'SenderId', { title: 'Sender ID', width: '60px' });
    tblSpecAddColumn<ColKey>(map, 'ReceiverId', { title: 'Receiver ID', width: '60px' });
    tblSpecAddColumn<ColKey>(map, 'Type', { type: 'DROPTEXT', width: '60px', fltOptions: typeTypeOptions() });
    tblSpecAddColumn<ColKey>(map, 'ObjectState', {
        type: 'DROPTEXT',
        title: 'Status',
        width: '60px',
        fltOptions: vendorTypeOptions(),
    });
    return map;
}

// default view
export function vendorListDefaultView(): TblViewSpec {
    return {
        key: '0',
        title: 'Default',
        sections: [
            {
                title: 'Identifiers',
                cols: ['Id', 'Name'],
            },
            {
                title: 'EDI',
                cols: ['SupportsEDI', 'SenderId', 'ReceiverId'],
            },
            {
                title: 'Usage',
                cols: ['Type', 'ObjectState'],
            },
        ],
        sortby: 'Id',
    };
}
